/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon20Light = forwardRef('ShapeCircleMOffIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.854 2.146a.5.5 0 1 0-.708.708L4.71 5.416a7 7 0 0 0 9.874 9.874l2.563 2.564a.5.5 0 0 0 .708-.708l-15-15Zm11.02 12.436L5.418 6.126a6 6 0 0 0 8.456 8.456Z" }),
        React.createElement("path", { d: "M16 10c0 .97-.23 1.887-.64 2.699l.74.739A7 7 0 0 0 6.562 3.9l.738.739A6 6 0 0 1 16 10Z" })));
});
